import axios from 'axios';

import { getAuthorizationHeader } from '../utils/getAuthHeader';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}`;

const url = `${API_URL}/status`;

export const fetchStatuses = async (departmentIds = []) => {
  const params = {};
  if (departmentIds && departmentIds.length > 0) {
    params.departmentIds = departmentIds.join(',');
  }

  const result = await axios.get(url, {
    headers: getAuthorizationHeader(),
    params,
  });
  return result.data;
};
export const fetchStatusByID = async (id) => {
  const result = await axios.get(`${url}/${id}`, { headers: getAuthorizationHeader() });
  return result.data;
};

export const createStatus = async (statusCommand) => {
  const result = await axios.post(url, statusCommand, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const modifyStatus = async (updateCommand) => {
  const result = await axios.put(`${url}/bulk-update`, updateCommand, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

// delete status
export const deleteStatus = async (id) => {
  const result = await axios.delete(`${url}/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};
